import axios from 'axios'
const { VUE_APP_API_URL, VUE_APP_TEST_ERROR } = process.env

const loadSQLData = async (payload) => {
  const result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/mysqlessentialinformation`

    const res = await axios
      .post(url, payload)
    if (res && res.data) {
      result.data = res.data
    }
    return result
  } catch (err) {
    result.error = true
    return result
  }
}

export {
  loadSQLData
}
